// lib/dealStages.ts — FE-эталон матрицы переходов стадий сделки (U-19, sled-V9 W5).
// Зеркало backend DealStage.canTransitionTo (DealStage.java:77-92, канон §8):
// 4 forward + 4 lost + 3 rollback + 2 terminal + 1 idempotent (HR-D8).
// Осознанное дублирование (ТЗ §5.1): у FE нет способа вызвать canTransitionTo без
// изменения DTO; дрейф ловит unit-тест dealStages.test.ts (эталон-зеркало).
// STAGE_COLORS — единый источник цвета стадии для DealStageChip и DealStagePath.

import type { DealStage } from '@/api/deals';

/** Канонический порядок стадий воронки: NEW → … → WON; LOST — справа (терминальная). */
export const STAGE_ORDER: DealStage[] = [
  'NEW',
  'QUALIFIED',
  'PROPOSAL',
  'NEGOTIATION',
  'WON',
  'LOST',
];

/** Матрица переходов §8: из какой стадии — в какие (пустой список = терминальная). */
export const STAGE_TRANSITIONS: Record<DealStage, DealStage[]> = {
  NEW: ['QUALIFIED', 'LOST'],
  QUALIFIED: ['PROPOSAL', 'LOST', 'NEW'],
  PROPOSAL: ['NEGOTIATION', 'LOST', 'QUALIFIED'],
  NEGOTIATION: ['WON', 'LOST', 'PROPOSAL'],
  WON: [],
  LOST: [],
};

/** Сопоставление стадии → MD3 color (R41; единый источник, перенесено из DealStageChip). */
export const STAGE_COLORS: Record<
  DealStage,
  'info' | 'primary' | 'warning' | 'secondary' | 'success' | 'error'
> = {
  NEW: 'info',
  QUALIFIED: 'primary',
  NEGOTIATION: 'warning',
  PROPOSAL: 'secondary',
  WON: 'success',
  LOST: 'error',
};

/**
 * Проверяет допустимость перехода {@code current → next} по канону §8
 * (зеркало {@code DealStage.canTransitionTo}).
 *
 * @param current текущая стадия.
 * @param next целевая стадия; {@code current === next} → {@code false} (HR-D8 idempotent).
 * @return {@code true} если переход разрешён state machine §8.
 */
export function canTransitionTo(current: DealStage, next: DealStage): boolean {
  return STAGE_TRANSITIONS[current].includes(next);
}
